// import React, { useState, useEffect } from "react";
// import homeImg from "../assets/yoga.jpg";
// import { motion } from "framer-motion";

// function Home() {
//   const [isMobile, setIsMobile] = useState(false);

//   // Detect mobile screen
//   useEffect(() => {
//     const checkSize = () => setIsMobile(window.innerWidth <= 480);
//     checkSize();
//     window.addEventListener("resize", checkSize);
//     return () => window.removeEventListener("resize", checkSize);
//   }, []);

//   return (
//     <div style={styles.container}>
//       <motion.img
//         src={homeImg}
//         alt="Yoga Home"
//         style={styles.image}
//         initial={{ opacity: 0, scale: 1.05 }}
//         animate={{ opacity: 1, scale: 1 }}
//         transition={{ duration: 1.5, ease: "easeOut" }}
//       />

//       {/* centered text */}
//       <div
//         style={{
//           ...styles.textBox,
//           padding: isMobile ? "20px 25px" : "40px 60px",
//           width: isMobile ? "85%" : "auto",
//         }}
//       >
//         <motion.h1
//           style={{
//             ...styles.title,
//             fontSize: isMobile ? "1.8rem" : "3rem",
//           }}
//           initial={{ opacity: 0, y: 50 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1, delay: 0.6 }}
//         >
//           🧘‍♀️ Welcome to Yoga Wellness
//         </motion.h1>

//         <motion.p
//           style={{
//             ...styles.subtitle,
//             fontSize: isMobile ? "1rem" : "1.3rem",
//           }}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 1, delay: 1.2 }}
//         >
//           Find your balance. Breathe. Relax.
//         </motion.p>
//       </div>

//       {/* floating circles */}
//       <div
//         style={{
//           ...styles.circle1,
//           width: isMobile ? "80px" : "150px",
//           height: isMobile ? "80px" : "150px",
//           top: isMobile ? "8%" : "10%",
//           left: isMobile ? "8%" : "5%",
//         }}
//       ></div>

//       <div
//         style={{
//           ...styles.circle2,
//           width: isMobile ? "70px" : "120px",
//           height: isMobile ? "70px" : "120px",
//           bottom: isMobile ? "10%" : "15%",
//           right: isMobile ? "8%" : "8%",
//         }}
//       ></div>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     position: "relative",
//     height: "100vh",
//     width: "100%",
//     overflow: "hidden",
//   },
//   image: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     filter: "brightness(75%)",
//   },
//   textBox: {
//     position: "absolute",
//     top: "45%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     color: "white",
//     textAlign: "center",
//     background: "rgba(0, 0, 0, 0.35)",
//     borderRadius: "12px",
//   },
//   title: {
//     marginBottom: "15px",
//     fontWeight: "700",
//     letterSpacing: "1px",
//     textShadow: "2px 2px 6px rgba(0,0,0,0.3)",
//   },
//   subtitle: {
//     marginBottom: "25px",
//     fontWeight: "300",
//     opacity: "0.9",
//   },
//   circle1: {
//     position: "absolute",
//     borderRadius: "50%",
//     background: "rgba(255,255,255,0.1)",
//     animation: "float 6s ease-in-out infinite",
//   },
//   circle2: {
//     position: "absolute",
//     borderRadius: "50%",
//     background: "rgba(255,255,255,0.08)",
//     animation: "float 8s ease-in-out infinite",
//   },
// };

// export default Home;

import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import Hero from "../assets/Hero1.mp4";

const Home = () => {
  const { scrollYProgress } = useScroll();
  const heroScale = useTransform(scrollYProgress, [0, 0.5], [1, 1.2]);
  const heroOpacity = useTransform(scrollYProgress, [0, 0.3], [1, 0]);

  const containerStyle = {
  width: '100vw',
  minHeight: '100vh',
  fontFamily: "'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  color: '#2d3748',
  overflowX: 'hidden',
  position: 'relative',
  left: '50%',
  right: '50%',
  marginLeft: '-50vw',
  marginRight: '-50vw',
  marginTop: '-10vh',
   
};



  const heroSectionStyle = {
  position: 'relative',
  width: '100%',
  maxWidth: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  
};


  const heroBackgroundStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
    backgroundColor: '#000'
    
  };

  const videoStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  zIndex: 1,
  maxWidth: '100%'
};


  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.3)',
    zIndex: 2
  };

  const heroContentStyle = {
    position: 'relative',
    zIndex: 3,
    textAlign: 'center',
    padding: '0 20px',
    maxWidth: '900px',
    width: '100%'
  };

  const logoStyle = {
    fontSize: 'clamp(1.8rem, 5vw, 4.5rem)',
    fontWeight: '300',
    color: '#ffffff',
    marginBottom: 'clamp(20px, 4vw, 30px)',
    letterSpacing: '3px',
    textTransform: 'lowercase'
  };

  const headlineStyle = {
    fontSize: 'clamp(1.5rem, 4vw, 3.5rem)',
    fontWeight: '700',
    color: '#ffffff',
    marginBottom: 'clamp(15px, 3vw, 25px)',
    lineHeight: '1.2',
    padding: '0 10px'
  };

  const subtitleStyle = {
    fontSize: 'clamp(0.95rem, 2vw, 1.4rem)',
    fontWeight: '300',
    color: '#f7fafc',
    marginBottom: 'clamp(30px, 5vw, 50px)',
    lineHeight: '1.7',
    maxWidth: '700px',
    margin: '0 auto',
    marginBottom: 'clamp(30px, 5vw, 50px)',
    padding: '0 15px'
  };

  const ctaContainerStyle = {
    display: 'flex',
    gap: 'clamp(12px, 2vw, 20px)',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: '0 10px'
  };

  const primaryButtonStyle = {
    padding: 'clamp(14px, 2vw, 18px) clamp(25px, 4vw, 40px)',
    fontSize: 'clamp(0.95rem, 1.5vw, 1.1rem)',
    fontWeight: '600',
    color: '#ffffff',
    background: 'linear-gradient(135deg, #81c784 0%, #66bb6a 100%)',
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 8px 25px rgba(102, 187, 106, 0.4)',
    whiteSpace: 'nowrap'
  };

  const secondaryButtonStyle = {
    padding: 'clamp(14px, 2vw, 18px) clamp(25px, 4vw, 40px)',
    fontSize: 'clamp(0.95rem, 1.5vw, 1.1rem)',
    fontWeight: '600',
    color: '#ffffff',
    background: 'transparent',
    border: '2px solid #ffffff',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap'
  };

  const aboutSectionStyle = {
    padding: 'clamp(60px, 10vw, 140px) clamp(20px, 4vw, 40px)',
    background: 'linear-gradient(180deg, #f0f4f8 0%, #e6f2f5 100%)',
    textAlign: 'center'
  };

  const sectionTitleStyle = {
    fontSize: 'clamp(1.75rem, 4vw, 3rem)',
    fontWeight: '700',
    color: '#2d3748',
    marginBottom: 'clamp(20px, 3vw, 30px)',
    background: 'linear-gradient(135deg, #588187 0%, #8b5c8b 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    padding: '0 15px'
  };

  const aboutTextStyle = {
    fontSize: 'clamp(1rem, 2vw, 1.3rem)',
    lineHeight: '1.8',
    color: '#4a5568',
    maxWidth: '800px',
    margin: '0 auto',
    marginBottom: 'clamp(20px, 3vw, 30px)',
    fontWeight: '400',
    padding: '0 20px'
  };

  const highlightsSectionStyle = {
    padding: 'clamp(60px, 10vw, 140px) clamp(20px, 4vw, 40px)',
    background: 'linear-gradient(180deg, #ffffff 0%, #faf5f0 100%)'
  };

  const highlightsGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))',
    gap: 'clamp(25px, 4vw, 40px)',
    maxWidth: '1200px',
    margin: 'clamp(40px, 6vw, 60px) auto 0',
    padding: '0 clamp(15px, 3vw, 20px)'
  };

  const cardStyle = {
    borderRadius: 'clamp(15px, 2vw, 20px)',
    overflow: 'hidden',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
    transition: 'all 0.4s ease',
    cursor: 'pointer',
    background: '#ffffff'
  };

  const cardImageStyle = {
    width: '100%',
    height: 'clamp(250px, 40vw, 320px)',
    objectFit: 'cover',
    display: 'block'
  };

  const cardContentStyle = {
    padding: 'clamp(20px, 4vw, 30px) clamp(15px, 3vw, 25px)',
    textAlign: 'center'
  };

  const cardTitleStyle = {
    fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
    fontWeight: '700',
    color: '#2d3748',
    marginBottom: 'clamp(10px, 2vw, 15px)'
  };

  const cardTextStyle = {
    fontSize: 'clamp(0.95rem, 1.5vw, 1rem)',
    color: '#718096',
    lineHeight: '1.6'
  };

  const highlights = [
    {
      title: 'Meditation',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80',
      description: 'Find inner peace through guided meditation practices that calm your mind and elevate your spirit.'
    },
    {
      title: 'Flexibility',
      image: 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?w=800&q=80',
      description: 'Unlock your body\'s potential with flowing movements designed to increase mobility and grace.'
    },
    {
      title: 'Strength',
      image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=80',
      description: 'Build powerful core strength and endurance through dynamic poses and intentional breathing.'
    }
  ];

  return (
    <div style={containerStyle}>
      {/* HERO SECTION */}
      <section style={heroSectionStyle}>
        <div style={heroBackgroundStyle}>
          <motion.video
            autoPlay
            loop
            muted
            playsInline
            style={videoStyle}
            initial={{ scale: 1.3, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
          >
            <source src={Hero} type="video/mp4" />
          </motion.video>
        </div>
        <motion.div 
          style={overlayStyle}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        />
        
        <motion.div 
          style={heroContentStyle}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <motion.h1 
            style={logoStyle}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            yoga refer.com
          </motion.h1>
          
          <motion.h2 
            style={headlineStyle}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
           Flow Into Your True Self.
          </motion.h2>
          
          <motion.p 
            style={subtitleStyle}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.7, duration: 0.8 }}
          >
            Your space for yoga, wellness guidance, and mindful living — all in one place.
          </motion.p>
          
          {/* <motion.div 
            style={ctaContainerStyle}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.8 }}
          >
            <motion.button 
              style={primaryButtonStyle}
              whileHover={{ scale: 1.05, boxShadow: '0 12px 35px rgba(102, 187, 106, 0.5)' }}
              whileTap={{ scale: 0.98 }}
            >
              Explore Programs
            </motion.button>
            <motion.button 
              style={secondaryButtonStyle}
              whileHover={{ scale: 1.05, background: 'rgba(255, 255, 255, 0.15)' }}
              whileTap={{ scale: 0.98 }}
            >
              Start Your Journey
            </motion.button>
          </motion.div> */}
        </motion.div>
      </section>

      {/* ABOUT SECTION */}
      <section style={aboutSectionStyle}>
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, margin: "-100px" }}
        >
          <h2 style={sectionTitleStyle}>Welcome to Your Sanctuary</h2>
          <p style={aboutTextStyle}>
            At <strong>yoga refer.com</strong>, we believe yoga is more than movement—it's a pathway 
            to holistic wellness. Our platform connects you with transformative practices 
            that nurture your mind, strengthen your body, and awaken your soul.
          </p>
          <p style={aboutTextStyle}>
            Whether you're beginning your journey or deepening your practice, we provide 
            expert guidance, supportive community, and the tools you need to thrive.
          </p>
        </motion.div>
      </section>

      {/* HIGHLIGHTS SECTION */}
      <section style={highlightsSectionStyle}>
        <motion.h2 
          style={{...sectionTitleStyle, textAlign: 'center'}}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          Explore Your Practice
        </motion.h2>
        
        <div style={highlightsGridStyle}>
          {highlights.map((item, index) => (
            <motion.div
              key={index}
              style={cardStyle}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true, margin: "-50px" }}
              whileHover={{ 
                y: -10, 
                boxShadow: '0 20px 50px rgba(0, 0, 0, 0.18)',
                transition: { duration: 0.3 }
              }}
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.4 }}
                style={{ overflow: 'hidden' }}
              >
                <img 
                  src={item.image} 
                  alt={item.title} 
                  style={cardImageStyle}
                />
              </motion.div>
              <div style={cardContentStyle}>
                <h3 style={cardTitleStyle}>{item.title}</h3>
                <p style={cardTextStyle}>{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;
